import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
import { getCountryField } from './country';
import { addErrorMessageToField, removeErrorMessageFromField } from './forms';

const getPostcodeField = () => {
  const postcodeField = document.querySelector('[name="supporter.postcode"]');

  return postcodeField instanceof HTMLInputElement ? postcodeField : null;
};

/**
 * Perform postcode validation for the given country and postcode fields, and add/remove error messages as appropriate.
 */
const validate = (params: {
  countryField: HTMLSelectElement | HTMLInputElement;
  event: 'blur' | 'change' | 'submit';
  postcodeField: HTMLInputElement;
}) => {
  const { countryField, event, postcodeField } = params;

  // Wait for EN to add its own error message, before we add/remove our own
  const DELAY_FOR_EN_ERROR_MESSAGE_PROCESSING_MS = 250;

  const countryCode = countryField.value;
  const postcode = postcodeField.value;

  if (!countryCode || !postcode) return; // don't validate when either field is empty, built-in validation will catch this
  if (!postcodeValidatorExistsForCountry(countryCode)) return;

  const postcodeIsValidForCountry = postcodeValidator(postcode, countryCode);

  if (postcodeIsValidForCountry) {
    if (event === 'blur' || event === 'change')
      setTimeout(
        () => removeErrorMessageFromField(postcodeField),
        DELAY_FOR_EN_ERROR_MESSAGE_PROCESSING_MS,
      );
  } else
    setTimeout(
      () => addErrorMessageToField(postcodeField, 'Please enter a valid postcode for your country'),
      event === 'blur' || event === 'change' ? DELAY_FOR_EN_ERROR_MESSAGE_PROCESSING_MS : 0,
    );
};

/**
 * Check whether a postcode is valid for the given country.
 *
 * Countries with no known postcode format are treated as always valid.
 */
export const validatePostcodeForCountry = () => {
  const countryField = getCountryField();
  const postcodeField = getPostcodeField();
  if (!countryField || !postcodeField) return;

  // Validate on field change/blur
  countryField.addEventListener('blur', () =>
    validate({ countryField, event: 'blur', postcodeField }),
  );
  countryField.addEventListener('change', () =>
    validate({ countryField, event: 'change', postcodeField }),
  );
  postcodeField.addEventListener('blur', () =>
    validate({ countryField, event: 'blur', postcodeField }),
  );
  postcodeField.addEventListener('change', () =>
    validate({ countryField, event: 'change', postcodeField }),
  );

  // Validate on form submit, working with ENvalidate
  window.onENValidateCustomValidationArray = window.onENValidateCustomValidationArray || [];
  window.onENValidateCustomValidationArray.push(() =>
    validate({ countryField, event: 'submit', postcodeField }),
  );
};
